import type {Directive} from 'vue'

type FadeImgOpts = {
    baseClass?: string
    loadedClass?: string
    errorClass?: string
    watchResize?: boolean
}
const fadeImgDirective: Directive<HTMLElement, FadeImgOpts | undefined> = {
    // ✅ SSR: directive existante + props SSR vides
    getSSRProps() {
        return {}
    },
    mounted(el, binding) {
        // ⚠️ En pratique mounted ne tourne déjà que côté client,
        // mais on garde une garde “béton”.
        if (!import.meta.client) return
        if (!(el instanceof HTMLImageElement)) return
        const opts = binding.value ?? {}
        const baseClass = opts.baseClass ?? 'fade-img'
        const loadedClass = opts.loadedClass ?? 'is-loaded'
        const errorClass = opts.errorClass ?? 'is-error'
        const watchResize = opts.watchResize ?? true
        el.classList.add(baseClass)
        let lastCurrentSrc: string | null = null
        const reveal = async () => {
            const chosen = el.currentSrc || el.src || null
            if (chosen && chosen !== lastCurrentSrc) {
                lastCurrentSrc = chosen
                el.classList.remove(loadedClass)
                el.classList.remove(errorClass)
            }
            if (!el.complete || el.naturalWidth === 0) return
            try {
                if (el.decode) await el.decode()
            } catch {
            }
            el.classList.add(loadedClass)
        }
        const onLoad = () => void reveal()
        const onError = () => el.classList.add(errorClass)
        el.addEventListener('load', onLoad)
        el.addEventListener('error', onError)
        void reveal()
        let onResize: (() => void) | null = null
        if (watchResize) {
            onResize = () => requestAnimationFrame(() => void reveal())
            window.addEventListener('resize', onResize)
        }
        ;(el as any).__fadeCleanup = () => {
            el.removeEventListener('load', onLoad)
            el.removeEventListener('error', onError)
            if (onResize) window.removeEventListener('resize', onResize)
        }
    },
    unmounted(el) {
        if (!(el instanceof HTMLImageElement)) return
        const cleanup = (el as any).__fadeCleanup
        if (cleanup) cleanup()
    },
}
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('fade-img', fadeImgDirective)
})
